// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic.js';
import {
  getSizeChartDetails,
  getSizeChartModuleXContentId,
  getSizeChartModuleXContent,
} from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.selectors';
import {
  fetchSizeGuideModuleX as fetchSizeGuideModuleXAction,
  scrollToIndex,
} from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.actions.js';
import {
  getIsPDPRedesignEnabled,
  getSizeChartNewDesignEnabled,
  getIsDynamicSizeChartEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import SafeComponent from '../../../../../hoc/withErrorBoundary/errorBoundary';

const SizeChart = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "SizeChartView" */ '../views/SizeChart.view.jsx'
    ),
  { ssr: false }
);
const NewSizeChart = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "NewSizeChart" */ '@tcp/core/src/components/common/molecules/ProductAddToBag/molecules/SizeChart/views/NewSizeChart.view.jsx'
    ),
  { ssr: false }
);

class SizeChartContainer extends React.PureComponent {
  render() {
    const {
      sizeChartDetails,
      categoryPath2Map,
      selectedFit,
      isNewReDesignProductSummary,
      newQVDesign,
      quickViewLabels,
      isNewPDPEnabled,
      isQuantitySection,
      primaryBrand,
      alternateBrand,
      isNewPJPPDPRedesignEnabled,
      setPdpTabSectionName,
      hideSizeGuideButton,
      isPDP,
      sizeChartModuleXContentId,
      fetchSizeGuideModuleX,
      activeTabSection,
      sizeChartModuleXContentTCP,
      sizeChartModuleXContentPJP,
      sizeChartModuleXContentSNJ,
      sizeChartModuleXContentGYM,
      sizeChartNewDesignEnabled,
      setPdpTabSectionIndex,
      isPDPRedesignEnabled,
      isDynamicSizeChartEnabled,
      sizeChartImageURL,
    } = this.props;

    return (
      <>
        {isNewPJPPDPRedesignEnabled ? (
          <NewSizeChart
            sizeChartDetails={sizeChartDetails}
            categoryPath2Map={categoryPath2Map}
            selectedFit={selectedFit}
            isNewReDesignProductSummary={isNewReDesignProductSummary}
            quickViewLabels={quickViewLabels}
            isNewPDPEnabled={isNewPDPEnabled}
            isQuantitySection={isQuantitySection}
            primaryBrand={primaryBrand || 'tcp'}
            alternateBrand={alternateBrand}
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
            setPdpTabSectionName={setPdpTabSectionName}
            hideSizeGuideButton={hideSizeGuideButton}
            isPDP={isPDP}
            sizeChartModuleXContentId={sizeChartModuleXContentId}
            fetchSizeGuideModuleX={fetchSizeGuideModuleX}
            activeTabSection={activeTabSection}
            sizeChartModuleXContentGYM={sizeChartModuleXContentGYM}
            sizeChartModuleXContentTCP={sizeChartModuleXContentTCP}
            sizeChartModuleXContentPJP={sizeChartModuleXContentPJP}
            sizeChartModuleXContentSNJ={sizeChartModuleXContentSNJ}
            setPdpTabSectionIndex={setPdpTabSectionIndex}
            isPDPRedesignEnabled={isPDPRedesignEnabled}
            sizeChartImageURL={sizeChartImageURL}
          />
        ) : (
          <SizeChart
            sizeChartDetails={sizeChartDetails}
            categoryPath2Map={categoryPath2Map}
            selectedFit={selectedFit}
            isNewReDesignProductSummary={isNewReDesignProductSummary}
            newQVDesign={newQVDesign}
            quickViewLabels={quickViewLabels}
            isNewPDPEnabled={isNewPDPEnabled}
            isQuantitySection={isQuantitySection}
            primaryBrand={primaryBrand}
            alternateBrand={alternateBrand}
            sizeChartNewDesignEnabled={sizeChartNewDesignEnabled}
            isPDP={isPDP}
            isDynamicSizeChartEnabled={isDynamicSizeChartEnabled}
            sizeChartImageURL={sizeChartImageURL}
          />
        )}
      </>
    );
  }
}

SizeChartContainer.propTypes = {
  sizeChartDetails: PropTypes.string,
  categoryPath2Map: PropTypes.shape([]),
  selectedFit: PropTypes.string,
  isNewReDesignProductSummary: PropTypes.bool,
  pdpLabels: PropTypes.shape({}),
  quickViewLabels: PropTypes.shape({
    addToBag: PropTypes.string,
    viewProductDetails: PropTypes.string,
  }).isRequired,
  newQVDesign: PropTypes.bool,
  isNewPDPEnabled: PropTypes.bool,
  isQuantitySection: PropTypes.bool,
  primaryBrand: PropTypes.string,
  alternateBrand: PropTypes.string,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  setPdpTabSectionName: PropTypes.func,
  hideSizeGuideButton: PropTypes.bool,
  isPDP: PropTypes.bool,
  fetchSizeGuideModuleX: PropTypes.func,
  sizeChartModuleXContentId: PropTypes.string,
  activeTabSection: PropTypes.string,
  sizeChartModuleXContentTCP: PropTypes.string,
  sizeChartModuleXContentPJP: PropTypes.string,
  sizeChartModuleXContentSNJ: PropTypes.string,
  sizeChartModuleXContentGYM: PropTypes.string,
  sizeChartNewDesignEnabled: PropTypes.bool,
  isDynamicSizeChartEnabled: PropTypes.bool,
};

SizeChartContainer.defaultProps = {
  sizeChartDetails: '',
  isNewReDesignProductSummary: false,
  categoryPath2Map: [],
  selectedFit: '',
  pdpLabels: {},
  newQVDesign: false,
  isNewPDPEnabled: false,
  isQuantitySection: false,
  primaryBrand: '',
  alternateBrand: '',
  isNewPJPPDPRedesignEnabled: false,
  setPdpTabSectionName: () => {},
  hideSizeGuideButton: false,
  isPDP: false,
  fetchSizeGuideModuleX: () => {},
  sizeChartModuleXContentId: '',
  activeTabSection: '',
  sizeChartModuleXContentTCP: '',
  sizeChartModuleXContentPJP: '',
  sizeChartModuleXContentSNJ: '',
  sizeChartModuleXContentGYM: '',
  sizeChartNewDesignEnabled: false,
  isDynamicSizeChartEnabled: false,
};

export const mapDispatchToProps = (dispatch) => {
  return {
    fetchSizeGuideModuleX: (payload) => {
      dispatch(fetchSizeGuideModuleXAction(payload));
    },
    setPdpTabSectionIndex: (payload) => dispatch(scrollToIndex(payload)),
  };
};
function mapStateToProps(state, props) {
  const brand = props?.primaryBrand?.toLowerCase() || 'tcp';
  return {
    sizeChartDetails: getSizeChartDetails(state),
    sizeChartModuleXContentId: getSizeChartModuleXContentId(brand),
    sizeChartModuleXContentTCP: getSizeChartModuleXContent(state, 'tcp'),
    sizeChartModuleXContentPJP: getSizeChartModuleXContent(state, 'pjp'),
    sizeChartModuleXContentSNJ: getSizeChartModuleXContent(state, 'snj'),
    sizeChartModuleXContentGYM: getSizeChartModuleXContent(state, 'gym'),
    sizeChartModuleXContent: getSizeChartModuleXContent(state),
    sizeChartNewDesignEnabled: getSizeChartNewDesignEnabled(state),
    isPDPRedesignEnabled: getIsPDPRedesignEnabled(state),
    isDynamicSizeChartEnabled: getIsDynamicSizeChartEnabled(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SafeComponent(SizeChartContainer));
